import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

export type StarProps = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function Star(props: StarProps) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="StarIcon"
      style={style}
    >
      <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
    </svg>
  )
}
